const home  = [
  {
    path: '/home',
    name: 'home',
    component: () => import('views/home/index.vue'),
    children :[
      {
        path: 'introduction',
        name: 'introduction',
        component: () => import('views/home/info/introduction.vue'),
        meta:{
          child:true,
          showtabbarfalse: true,
        }
      },
      {
        path: 'trendsDetail',
        name: 'trendsDetail',
        component: () => import('views/home/info/trendsDetail.vue'),
        meta:{
          child:true,
          showtabbarfalse: true,
        }
      }
    ]
  }
]
export default home